var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seats-container span-6"},_vm._l((_vm.seats),function(seat,index){return _c('div',{key:index,staticClass:"seat"},[_c('n-icon',{attrs:{"outline":seat.outlined,"name":"person","color":seat.color}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }